<section class="py-24 sm:py-32">
  <div class="mx-auto max-w-7xl px-6 lg:px-8">
    <!-- Header -->
    <div class="mx-auto max-w-2xl text-center" @fadeIn>
      <h2
        class="text-lg font-semibold leading-8 tracking-tight text-indigo-600"
        translate
      >
        testimonials.title
      </h2>
      <p
        class="mt-2 text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl"
        translate
      >
        testimonials.heading
      </p>
    </div>

    <!-- Loading State -->
    <div *ngIf="isLoading" class="mx-auto mt-16 text-center" @fadeIn>
      <div
        class="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-indigo-600 border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
      ></div>
      <p class="mt-4 text-gray-600" translate>testimonials.loading</p>
    </div>

    <!-- Error State -->
    <div *ngIf="error" class="mx-auto mt-16 text-center" @fadeIn>
      <div class="text-red-600 mb-2">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-10 w-10 mx-auto"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
          />
        </svg>
      </div>
      <p class="text-red-600">{{ error }}</p>
    </div>

    <!-- Testimonials Grid -->
    <div
      *ngIf="!isLoading && !error"
      class="mx-auto mt-16 grid max-w-2xl grid-cols-1 gap-8 sm:gap-x-6 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-3"
      @staggerFadeIn
    >
      <ng-container *ngFor="let review of customerReviews">
        <figure
          class="rounded-2xl bg-white p-8 shadow-lg ring-1 ring-gray-900/5 hover:shadow-xl transition-all duration-300"
        >
          <blockquote class="text-gray-900">
            <p class="text-base leading-7">"{{ review.review }}"</p>
          </blockquote>
          <figcaption class="mt-6 flex items-center gap-x-4">
            <div
              class="h-10 w-10 rounded-full bg-gray-50 flex items-center justify-center"
            >
              <span class="text-lg font-semibold text-indigo-600">{{
                review.name.charAt(0)
              }}</span>
            </div>
            <div>
              <div class="font-semibold text-gray-900">{{ review.name }}</div>
              <div class="text-gray-600">{{ review.companyName }}</div>
              <div class="text-sm text-gray-500 flex items-center gap-x-1">
                <svg
                  class="w-4 h-4"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"
                  />
                </svg>
                <a
                  href="https://instagram.com/{{
                    review.insta.replace('@', '')
                  }}"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="hover:text-indigo-600 transition-colors"
                >
                  {{ review.insta.replace("@", "") }}
                </a>
              </div>
            </div>
          </figcaption>
        </figure>
      </ng-container>

      <!-- Empty State -->
      <div
        *ngIf="customerReviews.length === 0"
        class="col-span-3 text-center py-12"
        @fadeIn
      >
        <p class="text-gray-500" translate>testimonials.empty</p>
      </div>
    </div>
  </div>
</section>
